<template>
  <v-card color="white">
    <v-container class="pa-0" v-if="(GETTERS_EQUIMENT !== null) && (GETTERS_REFERENCES('method').length > 0)">
      <v-row>
        <v-col cols="12" lg="6">
          <b class="help-step" style="cursor:help;" @click="show_help($t('facility.text'), $t('facility.help'))">
            {{$t('facility.text')}}
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  style="cursor:help;"
                >
                  <v-icon color="grey lighten-1">mdi-help-circle</v-icon>
                </v-btn>
              </template>
              <span v-html="$t('facility.help')"></span>
            </v-tooltip>
          </b>

          <div class="input-container input-name">
            <v-select
              :items="scientificAttitude"
              item-text="text"
              item-value="value"
              outlined
              v-model="scientificAttitudeId"
              :rules="[(value) => (value === 0) ? $t('required') : true]"
              :error="errorExperimentalStation"
            ></v-select>
          </div>
        </v-col>
        <v-col cols="12" lg="6">
          <b class="help-step" style="cursor:help;" @click="show_help($t('requestedExperimentalStations.text'), $t('requestedExperimentalStations.help'))">
            {{$t('requestedExperimentalStations.text')}}
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  style="cursor:help;"
                >
                  <v-icon color="grey lighten-1">mdi-help-circle</v-icon>
                </v-btn>
              </template>
              <span v-html="$t('requestedExperimentalStations.help')"></span>
            </v-tooltip>
          </b>

          <v-select
            :items="filteredStation"
            item-text="name"
            item-value="id"
            outlined
            :disabled="scientificAttitudeId == 0"
            
            v-model="experimentalStation"
            :rules="[rules.required]"
            :error="errorExperimentalStation"
            @input="experimentalStation.length !== 0 ? errorExperimentalStation = false : errorExperimentalStation = true"
          ></v-select>

          <div v-if="is_not_available_station">
            <p style="color: red;font-size: 16px;font-style: italic;"> выбранная станция временно недоступна для проведения экспериментов </p>
          </div>
          <div>
            <p>{{ descriptionStation }} </p>
          </div>

        </v-col>
      </v-row>

      <v-row>
        <v-col cols="8">
          <b class="help-step" style="cursor:help;" @click="show_help($t('methodMeasurement.text'), $t('methodMeasurement.help'))">
            {{$t('methodMeasurement.text')}}
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  style="cursor:help;"
                >
                  <v-icon color="grey lighten-1">mdi-help-circle</v-icon>
                </v-btn>
              </template>
              <span v-html="$t('methodMeasurement.help')"></span>
            </v-tooltip>
          </b>

          <v-select
            :items="filteredMethod === null ? methodName : filteredMethod"
            item-text="name"
            outlined
            item-value="id"            
            v-model="methodOfMeasurement"
            :rules="[rules.required]"
            :error="errorMethodOfMeasurement"
            @input="errorMethodOfMeasurement = !methodOfMeasurement"
          ></v-select>
        </v-col>
        <v-col cols="4">
            <div>
              <p>{{ descriptionMethod }} </p>
            </div>
        </v-col>
      </v-row>
      

      <v-row>
        <v-col cols="12">
          <b class="help-step" style="cursor:help;" @click="show_help($t('optionalEquipmentLabel.text'), $t('optionalEquipmentLabel.help'))">
            {{$t('optionalEquipmentLabel.text')}}
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  style="cursor:help;"
                >
                  <v-icon color="grey lighten-1">mdi-help-circle</v-icon>
                </v-btn>
              </template>
              <span v-html="$t('optionalEquipmentLabel.help')"></span>
            </v-tooltip>
          </b>

          <v-select
            :items="filteredAdditional"
            item-text="name"
            outlined
            item-value="id"
            v-model="optionalEquipment"
            multiple
            chips
          ></v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <b class="help-step" style="cursor:help;" @click="show_help($t('applicantEquipment.text'), $t('applicantEquipment.help'))">
            {{$t('applicantEquipment.text')}}
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  style="cursor:help;"
                >
                  <v-icon color="grey lighten-1">mdi-help-circle</v-icon>
                </v-btn>
              </template>
              <span v-html="$t('applicantEquipment.help')"></span>
            </v-tooltip>
          </b>

          <v-textarea
            v-model="applicantEquipment"
            outlined
            type="number"
            counter="300"
            maxLength="300"
            rows="1"
          ></v-textarea>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <b class="help-step" style="cursor:help;" @click="show_help($t('experimentPlan.text'), $t('experimentPlan.help'))">
            {{$t('experimentPlan.text')}}
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  style="cursor:help;"
                >
                  <v-icon color="grey lighten-1">mdi-help-circle</v-icon>
                </v-btn>
              </template>
              <span v-html="$t('experimentPlan.help')"></span>
            </v-tooltip>
          </b>

          <v-textarea
            v-model="experimentPlans"
            outlined
            
            :error="errorExperimentPlans"
            :rules="[rules.required]"
            @input="experimentPlans.length !== 0 ? errorExperimentPlans = false : errorExperimentPlans = true"
            type="number"
            counter="3000"
            maxLength="3000"
          ></v-textarea>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <b class="help-step" style="cursor:help;" @click="show_help('', $t('beamTimes.help'))">
            {{$t('beamTimes.text')}} {{scientificAttitudeId == 2 ? ' (в днях).' : ' (в часах).'}}
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  style="cursor:help;"
                >
                  <v-icon color="grey lighten-1">mdi-help-circle</v-icon>
                </v-btn>
              </template>
              <span v-html="$t('beamTimes.help')"></span>
            </v-tooltip>
          </b>

          <div style="margin: 25px;">
            <v-slider
              :value="calc_beamtime"
              :tick-labels="av_time"
              min="0"
              :error="errorBeamTime"
              :rules="[rules.beamtime]"
              :max="slider_max"
              step="1"
              show-ticks="always"
              thumb-label="always"
              ticks="always"
              tick-size="4"
              color="#022B61"
              @change="change_beamtime($event)"
            >
              <template v-if="scientificAttitudeId == 1 || scientificAttitudeId == 3" v-slot:thumb-label="props">
                <v-icon color="grey lighten-1">mdi-clock-time-nine-outline</v-icon>
              </template>
            </v-slider>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>
<script>

import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'ToolSelection',
 
  data() {
    return {
      errorBeamTime: true,
      errorExperimentalStation: false,
      errorMethodOfMeasurement: false,
      errorExperimentPlans: false,
      experimentalStation: null,
      methodOfMeasurement: null,
      experimentPlans: '',
      applicantEquipment: '',
      beamTime: 0,
      optionalEquipment: null,
      method: [],
      filteredMethod: null,
      filteredStation: [],
      filteredAdditional: [],
      descriptionMethod: '',
      descriptionStation: '',
      is_not_available_station: false,
      scientificAttitude: [
        {value: 2, text: this.$t('Step3.reactor')}, 
        {value: 1, text: this.$t('Step3.synchrotron')},
        {value: 3, text: 'Лабораторные приборы'},
      ],
      scientificAttitudeId: 0,
      savedscientificAttitudeId: 0,
      rules: {
        required: (value) => (value === undefined || value === null || value.length === 0 || value == 0) ? this.$t('required') : true,
        beamtime: (value) => (value === undefined || value === null || value > 720 || value == 0) ? this.$t('required') : true,
      },
      sinch_av_time: [0,4,8,24,48,72,96,120],
      react_av_time: ['0','1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24','25','26','27','28','29','30'],

    };
  },

  watch: {
    'GETTERS_NEW_PROPOSAL_STEPPER_NEED_CHECK.step3'(val){
      if(val){
        var status = this.validateInputs()

        this.NEW_PROPOSAL_UPDATE_STEPPER_CHECK_STATUS({name: 'step3', value: status})
        this.NEW_PROPOSAL_UPDATE_STEPPER_NEED_CHECK({name: 'step3', value: false})

      }
    },
    
    async experimentalStation(val) {
      if(val != this.GETTERS_FILES.stations[0]){
        this.methodOfMeasurement = null
        this.optionalEquipment = []
      }
      else{
        this.methodOfMeasurement = this.GETTERS_FILES.method
        this.optionalEquipment = this.GETTERS_FILES.additional_equipment
      }

      this.descriptionStation = ''
      this.GETTERS_EQUIMENT.forEach(item => {
        if(item.id === val){
          this.descriptionStation = item.description && item.description.length > 0 ? item.description : ''
          this.is_not_available_station = !item.is_available
        }
      })

      if(this.is_not_available_station){
        this.filteredMethod = []
      }
      else{
        this.filteredMethod = this.methodName.filter(item => {
          for (let i = 0; i < item.method_equipment.length; i++) {
            if (item.method_equipment[i] === val) {
              return item
            }
          }
        })
      }

      this.filteredAdditional = []
      this.GETTERS_EQUIMENT.forEach((item) => {
        if(item.type === 'additional'){
          for (let i = 0; i < item.additional_for.length; i++) {
            if (item.additional_for[i] === val) {
              this.filteredAdditional.push({name: item.name, id: Number(item.id) })
            }
          }
        }
      });

      this.errorMethodOfMeasurement = !this.methodOfMeasurement

      this.UPDATE_QUIZE(
          {
            stations: val > 0 ? [val] : null,
          },
        );
    },

    async methodOfMeasurement(val) {
      this.descriptionMethod = ''
      this.GETTERS_REFERENCES('method').forEach(item => {
        if(item.id === val) 
          this.descriptionMethod = item.description && item.description.length > 0 ? item.description : ''
      })

      this.UPDATE_QUIZE(
          {
            method: val,
          },
        );
    },

    async experimentPlans(val) {
      this.UPDATE_QUIZE(
          {
            experiment_strategy: val,
          },
        );
    },
    
    async applicantEquipment(val) {
      this.UPDATE_QUIZE(
          {
            applicant_equipment: val,
          },
        );
    },

    async optionalEquipment(val) {
      this.UPDATE_QUIZE(
          {
            additional_equipment: val === null ? [] : val,
          },
        );
    },

    scientificAttitudeId(val) {
      this.filteredStation = []
      
      var name = ''
      if(val == 1)
        name = 'synchrotron'
      if(val == 2)
        name = 'reactor'
      if(val == 3)
        name = 'lab'

      if(val > 0){
        this.GETTERS_EQUIMENT.forEach((item) => {
          item.type === 'station' && item.megascience_type === name ? this.filteredStation.push({name: item.name, id: Number(item.id)}) : null
        });
      }

      if(this.savedscientificAttitudeId != val){
        this.experimentalStation = null
        this.beamTime = 0
      }
      else{
        this.experimentalStation = this.GETTERS_FILES.stations[0]
        this.beamTime = this.GETTERS_FILES.experiment_duration
      }
      this.errorBeamTime = !(this.beamTime > 0 && this.beamTime <= 720)
      this.errorExperimentalStation = !this.experimentalStation

      this.UPDATE_QUIZE(
        {
          stations: this.experimentalStation > 0 ? [this.experimentalStation] : null,
          method: this.methodOfMeasurement,
          experiment_strategy: this.experimentPlans,
          applicant_equipment: this.applicantEquipment,
          experiment_duration: this.beamTime,
          additional_equipment: this.optionalEquipment
        },
      );
    },

    GETTERS_EQUIMENT(val) {
      this.experimentPlans = this.GETTERS_FILES.experiment_strategy
      this.applicantEquipment = this.GETTERS_FILES.applicant_equipment
      if (this.experimentPlans === null || this.experimentPlans.length === 0) this.errorExperimentPlans = true

      this.scientificAttitudeId = 0
      this.savedscientificAttitudeId = 0

      val.forEach(item => {
        if (item.id === this.GETTERS_FILES.stations[0]) {
          if (item.megascience_type === 'synchrotron'){
            this.scientificAttitudeId = 1
            this.savedscientificAttitudeId = 1
          }
          if (item.megascience_type === 'reactor'){
            this.scientificAttitudeId = 2
            this.savedscientificAttitudeId = 2
          }
          if (item.megascience_type === 'lab'){
            this.scientificAttitudeId = 3
            this.savedscientificAttitudeId = 3
          }
        }
      })
    },

    'GETTERS_FILES.experiment_strategy'(val) {
      if (val === null || val.length === 0) this.errorExperimentPlans = true    
    },

  },

  methods: {
    ...mapMutations([
      'UPDATE_QUIZE',
      'UPDATE_HELPER_DIALOG',
      'NEW_PROPOSAL_UPDATE_STEPPER_CHECK_STATUS',
      'NEW_PROPOSAL_UPDATE_STEPPER_NEED_CHECK',
    ]),

    show_help(header = '', text = ''){
      this.UPDATE_HELPER_DIALOG({
        'show' : true,
        'helper_data': {
          'header': header,
          'text': text,
        }
      })
    },

    change_beamtime(val){
      var beam_time
      
      if(this.scientificAttitudeId == 1 || this.scientificAttitudeId == 3){
        beam_time =this.sinch_av_time[val]
      }
      else if(this.scientificAttitudeId == 2){
        beam_time = val * 24        
      }

      this.beamTime = beam_time
      this.errorBeamTime = !(this.beamTime > 0 && this.beamTime <= 720)
      this.UPDATE_QUIZE({experiment_duration: this.beamTime});
    },
    
    validateInputs() {
      var res = true
      if (this.experimentalStation == null ){
        this.errorExperimentalStation = true
        res = false
      }
      if (this.methodOfMeasurement == null ){
        this.errorMethodOfMeasurement = true
        res = false
      }
      if (this.experimentPlans === null || this.experimentPlans.length === 0){
        this.errorExperimentPlans = true
        res = false
      }
      if (this.beamTime === null || this.beamTime <= 0 || this.beamTime > 720){
        this.errorBeamTime = true
        res = false
      }

      return res
    },

  },
  
  computed: {
    ...mapGetters([
      'GETTERS_EQUIMENT', 
      'GETTERS_REFERENCES',
      'GETTERS_FILES',

      'GETTERS_NEW_PROPOSAL_STEPPER_NEED_CHECK',
    ]),

    calc_beamtime(){
      var t = parseInt(this.beamTime)
      if(this.scientificAttitudeId == 1 || this.scientificAttitudeId == 3){
        var index = this.sinch_av_time.indexOf(t)
        if(index == -1){
          if(t == 0)
            index = 0
          else if(t > 120)
            index = 7
          else if(t > 8){
            index = Math.ceil(t / 24) + 2
          }
          else if(t < 4){
            index = 1
          }
          else
            index = 2
        }
        return index
      }
      else if(this.scientificAttitudeId == 2){
        t = Math.ceil(t / 24)
        if(t > 30) 
          t = 30
        return t
      }
    },

    slider_max(){
      if(this.scientificAttitudeId == 1 || this.scientificAttitudeId == 3){
        return 7
      }
      else if(this.scientificAttitudeId == 2){
        return 30        
      }
      else
        return 0        
    },

    av_time(){
      return this.scientificAttitudeId == 2 ? this.react_av_time : this.sinch_av_time
    },

    methodName() {
      this.GETTERS_REFERENCES('method').forEach((item) => {
        this.method.push({ name: item.name, id: Number(item.id), method_equipment: item.method_equipment });
      });

      return this.method;
    },
  },
};
</script>

<style scoped>
  .mb-12.card.v-card.v-sheet.theme--light.white{
    box-shadow: none;
  }
  .select{
    width:100%;
  }

  h4{
    color: #949494;
    letter-spacing: -0.015em;
    font-style: normal;
    font-weight: 500;
  }

  .help-step {
    margin: 0 auto 0 0;
    color: #949494;
  }
</style>
